export default __webpack_public_path__ + "static/media/ctgc-winner.png";